module.exports = __webpack_public_path__ + "static/media/AP_ES_Z1.6019321d.png";